<script setup>
import CloseSvg from '@/assets/close.svg?skipsvgo'

</script>

<template>
    <i
        :class="['close-button']"
        role="button"
    >
        <CloseSvg />
    </i>
</template>

<style lang="scss">
@use "@bam/scss" as *;

:root {
    --close-button-color: #{v(color-white)};
    --close-button-color--hover: #{v(color-primary)};
}

.close-button {
    cursor: pointer;
    color: var(--close-button-color);
    transition: color v(duration-default) v(easing-default);

    @include hover {
         color: var(--close-button-color--hover);
    }

    svg {
        @include svg-auto-color;
        color: inherit;
    }
}
</style>
